import { connect } from 'react-redux';
import { setType, setSize, setColour, setQuantity } from 'Actions/shirt';
import { updateValids } from 'Actions/form';
import ShirtForm from './Shirt'

const mapStateToProps = (state) => ({
    shirtType: state.shirt.type,
    shirtSize: state.shirt.size,
    shirtColour: state.shirt.colour,
    shirtQuantity: state.shirt.quantity,
    valids: state.form.valids,
    nextAttempted: state.form.nextAttempted,

    concessionData: state.form.concessionInfo,
});

const mapDispatchToProps = (dispatch) => ({
    setType: (shirt_type) => dispatch(setType(shirt_type)),
    setSize: (shirt_size) => dispatch(setSize(shirt_size)),
    setColour: (shirt_colour) => dispatch(setColour(shirt_colour)),
    setQuantity: (shirt_quantity) => dispatch(setQuantity(shirt_quantity)),
    updateValids: (new_valids) => dispatch(updateValids(new_valids))
})

export default connect (mapStateToProps, mapDispatchToProps)(ShirtForm);